import axiosOrders from '../../axios/quickOrders';
var qs = require( 'qs' ); // necessary for stringifying json for http requests to API

import router from '../../router/router';

const state = {

    merchants               : [ { merchantId: parseInt( process.env.VUE_APP_MERCHANT_ID ), name: process.env.VUE_APP_MERCHANT_NAME } ],
    merchantLocations       : JSON.parse( localStorage.getItem( 'merchantLocations' ) ) || [],
    currentMerchant         : { merchantId: parseInt( process.env.VUE_APP_MERCHANT_ID ), name: process.env.VUE_APP_MERCHANT_NAME },
    currentMerchantLocation : JSON.parse( localStorage.getItem( 'currentLocation' ) ) || null,

    locationError           : null
};

const mutations = {

    setLocationError( state, err ){

        state.locationError = err;
    },
    setLocations( state, locations ){

        state.merchantLocations = locations;
        localStorage.setItem( 'merchantLocations', JSON.stringify( locations ) );
    },
    setCurrentLocation( state, location ){

        state.currentMerchantLocation = location;
        localStorage.setItem( 'currentLocation', JSON.stringify( location ) );
    },
    clearData(){

        state.merchantLocations       = [];
        state.currentMerchantLocation = null;
        localStorage.removeItem( 'merchantLocations' );
        localStorage.removeItem( 'currentLocation'   );
    }
};

const actions = {

    // thoughts: when switching merchants, reset locations to [] so 'needsLocations' goes to true
    getLocations( { commit, getters } ){

        axiosOrders({

            method: 'post',
            url: '/getLocations',
            data: qs.stringify( {

                merchantId: getters.currentMerchant.merchantId,
            } ),
            headers: {

                'Content-Type' : 'application/x-www-form-urlencoded',
                'AuthType'     : 'JWT',
                'ApiKey'       : process.env.VUE_APP_API_KEY,
                'Token'        : localStorage.getItem( 'token' ) || null
            }
        }).then( res => {

            if( res.data.responseCode == 100 ){

                const locations = res.data.data;

                let formattedLocations = [];
                locations.forEach( location => {

                    formattedLocations.push( {

                        'name'            : location.MerchantLocation.name,
                        'locationId'      : location.QuickMerchantLocation.merchantLocationId,
                        'menuLocationId'  : location.QuickMerchantLocation.quickMerchantLocationId,
                        'imagePath'       : location.Image.path,
                        'imageName'       : location.Image.name,
                        'menuVersion'     : location.QuickMerchantLocation.menuVersion,
                        'acceptingOrders' : location.QuickMerchantLocation.acceptingOrders
                    });
                });

                commit( 'setLocationError', null );
                commit( 'setLocations', formattedLocations );
            }
        }).catch( err => {

            console.log( 'the error: ', err );
            commit( 'setLocationError', err );
        });
    },
    selectLocation( { commit, getters, dispatch, rootGetters }, input ){

        if( input.refreshMenu ) dispatch( 'orderMenu/needsMenu', null, { root: true } );
        commit( 'setCurrentLocation', input.location );
        router.push( { name : ( [ "", null ].includes( rootGetters.previousRoute.name ) ) ? 'home' : ( rootGetters[ 'nav/intendedRoute' ] != null ? rootGetters[ 'nav/intendedRoute' ] : rootGetters.previousRoute.name ) } );
        dispatch( 'nav/saveIntendedRoute', null, { root: true } );
    },
    clearData( { commit } ){

        commit( 'clearData' );
    }
};

const getters = {

    allLocations    : state => state.merchantLocations,
    allMerchants    : state => state.merchants,
    currentMerchant : state => state.currentMerchant,
    currentLocation : state => state.currentMerchantLocation,
    needsLocations  : state => state.merchantLocations.length == 0, // if there are no locations, we need to get some. UNDER ASSUMPTION EVERY MERCHANT HAS AT LEAST 1 LOCATION
    locationError   : state => state.locationError
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};